import {
  format,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  eachDayOfInterval,
  addMonths,
  subMonths,
  addDays,
  subDays,
  addWeeks,
  subWeeks,
  isSameDay,
  isSameMonth,
  isToday,
  parseISO,
  getDay,
} from 'date-fns';
import { ko } from 'date-fns/locale';

export {
  format,
  addMonths,
  subMonths,
  addDays,
  subDays,
  addWeeks,
  subWeeks,
  isSameDay,
  isSameMonth,
  isToday,
  parseISO,
  getDay,
};

export function getCalendarDays(date: Date): Date[] {
  const monthStart = startOfMonth(date);
  const monthEnd = endOfMonth(date);
  const calendarStart = startOfWeek(monthStart, { weekStartsOn: 0 });
  const calendarEnd = endOfWeek(monthEnd, { weekStartsOn: 0 });
  return eachDayOfInterval({ start: calendarStart, end: calendarEnd });
}

export function getWeekDays(date: Date): Date[] {
  const start = startOfWeek(date, { weekStartsOn: 0 });
  return eachDayOfInterval({ start, end: addDays(start, 6) });
}

export function formatKorean(date: Date, fmt: string): string {
  return format(date, fmt, { locale: ko });
}

export function formatKoreanDate(date: Date): string {
  return format(date, 'M월 d일 (EEE)', { locale: ko });
}

export function formatKoreanFull(date: Date): string {
  return format(date, 'yyyy년 M월 d일 EEEE', { locale: ko });
}

export function formatKoreanMonth(date: Date): string {
  return format(date, 'yyyy년 M월', { locale: ko });
}

export function formatKoreanWeekRange(weekDays: Date[]): string {
  const start = weekDays[0];
  const end = weekDays[6];
  if (start.getMonth() === end.getMonth()) {
    return format(start, 'M월 d일', { locale: ko }) + ' – ' + format(end, 'd일', { locale: ko });
  }
  return format(start, 'M월 d일', { locale: ko }) + ' – ' + format(end, 'M월 d일', { locale: ko });
}

export function toDateString(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

export function generateId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export const WEEKDAY_LABELS = ['일', '월', '화', '수', '목', '금', '토'];
